import './infos.js';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/css/index.css';
import './assets/scss/main.scss';

import 'primeicons/primeicons.css';
import { locale } from '@/plugins/primevue-locale-dictionary';
import GiraBrasilTheme from '@/assets/primevue-theme';
import { initializeColorMode } from '@/composables/useColorMode';

import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import Password from 'primevue/password';
import ProgressSpinner from 'primevue/progressspinner';
import ScrollPanel from 'primevue/scrollpanel';
import Checkbox from 'primevue/checkbox';
import ToggleSwitch from 'primevue/toggleswitch';
import ConfirmDialog from 'primevue/confirmdialog';
import Divider from 'primevue/divider';
import ModalLoading from '@/components/loading/loading.vue';
import Select from 'primevue/select';
import MultiSelect from 'primevue/multiselect';
import Textarea from 'primevue/textarea';
import BadgeDirective from 'primevue/badgedirective';
import InputNumber from 'primevue/inputnumber';
import DatePicker from 'primevue/datepicker';
import FloatLabel from 'primevue/floatlabel';
import Avatar from 'primevue/avatar';
import Rating from 'primevue/rating';
import Galleria from 'primevue/galleria';
import Dialog from 'primevue/dialog';
import NavBar from '@/components/Navbar'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Ripple from 'primevue/ripple';

import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';

const app = createApp(App);

initializeColorMode();

app.use(store).use(router).use(PrimeVue, {
    locale,
    theme: {
        preset: GiraBrasilTheme,
        options: {
            prefix: 'p',
            darkModeSelector: '.dark',
            cssLayer: false,
        },
    },
    ripple: true,
}).use(ConfirmationService).use(ToastService)

app.component('Button', Button);
app.component('InputText', InputText);
app.component('InputMask', InputMask);
app.component('Password', Password);
app.component('ProgressSpinner', ProgressSpinner);
app.component('ScrollPanel', ScrollPanel);
app.component('Checkbox', Checkbox);
app.component('ToggleSwitch', ToggleSwitch);
app.component('ConfirmDialog', ConfirmDialog);
app.component('Toast', Toast);
app.component('Divider', Divider);
app.component('ModalLoading', ModalLoading);
app.component('Dropdown', Select);
app.component('MultiSelect', MultiSelect);
app.component('Textarea', Textarea);
app.component('InputNumber', InputNumber);
app.component('Calendar', DatePicker);
app.component('FloatLabel', FloatLabel);
app.component('Avatar', Avatar);
app.component('Rating', Rating);
app.component('Galleria', Galleria);
app.component('Dialog', Dialog);
app.component('NavBar', NavBar);
app.component('DataTable', DataTable);
app.component('Column', Column);

app.directive('badge', BadgeDirective);
app.directive('ripple', Ripple);

app.mount('#app');
